import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-create-address',
  templateUrl: './create-address.component.html',
  styleUrls: ['./create-address.component.css']
})
export class CreateAddressComponent {


  createAddressForm = new FormGroup({
    selectAddressType: new FormControl('', [Validators.required,]),
    companyName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    firstName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    addressEmail: new FormControl('', [Validators.required, Validators.email, Validators.minLength(4), Validators.pattern('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})')]),
    addressOne: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    addressTwo: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    adCountry: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    adState: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    adCity: new FormControl('', [Validators.required, Validators.minLength(1), Validators.pattern('^[a-zA-Z]+$')]),
    adZip: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(6)]),
    adPhone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
  });

  address_validation_messages = {
    'selectAddressType': [
      { type: 'required', message: 'company name is required.' },
      { type: 'minlength', message: 'company name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'company name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your company name must contain only letters.' }
    ],
    'companyName': [
      { type: 'required', message: 'company name is required.' },
      { type: 'minlength', message: 'company name must be at least 3 characters long.' },
      { type: 'maxlength', message: 'company name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your company name must contain only letters.' }
    ],
    'firstName': [
      { type: 'required', message: 'first name is required.' },
      { type: 'minlength', message: 'first name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'first name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your first name must contain only letters.' }
    ],
    'lastName': [
      { type: 'required', message: 'last name is required.' },
      { type: 'minlength', message: 'last name must be at least 1 characters long.' },
      { type: 'maxlength', message: 'last name cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your last name must contain only letters.' }
    ],
    'addressEmail': [
      { type: 'required', message: 'email is required.' },
      { type: 'minlength', message: 'email must be at least 4 characters long.' },
      { type: 'maxlength', message: 'email cannot be more than 25 characters long.' },
      { type: 'pattern', message: 'Please enter a valid email.' }
    ],
    'addressOne': [
      { type: 'required', message: 'Address1 is required.' },
      { type: 'minlength', message: 'Address1 must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Address1 cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Address1 must contain only letters.' }
    ],
    'addressTwo': [
      { type: 'required', message: 'Address1 is required.' },
      { type: 'minlength', message: 'Address1 must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Address1 cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Address1 must contain only letters.' }
    ],
    'adCountry': [
      { type: 'required', message: 'Country is required.' },
      { type: 'minlength', message: 'Country must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Country cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your Country must contain only letters.' }
    ],
    'adState': [
      { type: 'required', message: 'State is required.' },
      { type: 'minlength', message: 'State must be at least 1 characters long.' },
      { type: 'maxlength', message: 'State cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your State must contain only letters.' }
    ],
    'adCity': [
      { type: 'required', message: 'City is required.' },
      { type: 'minlength', message: 'City must be at least 1 characters long.' },
      { type: 'maxlength', message: 'City cannot be more than 100 characters long.' },
      { type: 'pattern', message: 'Your City must contain only letters.' }
    ],
    'adZip': [
      { type: 'required', message: 'Zip is required.' },
      { type: 'minlength', message: 'Zip must be at least 10 numeric long.' },
      { type: 'maxlength', message: 'phone number cannot be more than 10 numeric long.' }
    ],
    'adPhone': [
      { type: 'required', message: 'phone number is required.' },
      { type: 'minlength', message: 'phone number must be at least 10 numeric long.' },
      { type: 'maxlength', message: 'phone number cannot be more than 10 numeric long.' }
    ]
  }

  cancelAddress(){
    
  }
  addAddress(){

  }
}
